import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/term/엔라이튼-안전보건경영방침.png");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/next@15.3.8_@babel+core@7.28.5_@opentelemetry+api@1.9.1_babel-plugin-macros@3.1.0_react-dom@1_qju5jnn2ro242seicfecxp7w4q/node_modules/next/dist/client/image-component.js");
